module.exports = __webpack_public_path__ + "static/media/artist_login_btn.bd34316e.png";